export default __webpack_public_path__ + "static/media/1.5FoldEmbryo.6bf185ba.svg";